// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('header-menu').forEach(menu => {
//     const d = menu.querySelector('details'), s = d.querySelector('summary');
//     menu.onmouseenter = () => (d.open = true, s.ariaExpanded = true);
//     menu.onmouseleave = () => (d.open = false, s.ariaExpanded = false);
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  let closeTimeout = null;
  let currentOpenMenu = null;

  document.querySelectorAll('header-menu').forEach(menu => {
    const d = menu.querySelector('details');
    const s = d.querySelector('summary');

    menu.addEventListener('mouseenter', () => {
      // Immediately close the previously open menu
      if (currentOpenMenu && currentOpenMenu !== menu) {
        const prevD = currentOpenMenu.querySelector('details');
        const prevS = prevD.querySelector('summary');
        prevD.open = false;
        prevS.ariaExpanded = false;
      }

      clearTimeout(closeTimeout); // cancel delayed close
      d.open = true;
      s.ariaExpanded = true;
      currentOpenMenu = menu;
    });

    menu.addEventListener('mouseleave', () => {
      closeTimeout = setTimeout(() => {
        // If mouse is not hovering any menu, close current one
        const isHoveringMenu = Array.from(document.querySelectorAll('header-menu'))
          .some(m => m.matches(':hover'));

        if (!isHoveringMenu && currentOpenMenu === menu) {
          d.open = false;
          s.ariaExpanded = false;
          currentOpenMenu = null;
        }
      }, 200); // delay only when leaving to nowhere
    });
  });
});
